<template>
    <div class="birthday">
        <div class="discount_bg">
            <img
                class="birth_usebtn"
                src="./../../image/scflow/birth_usebtn.png"
                @click="usebirCount()"
            >
            <p class="price">满{{ birthdayObj.data.mininum }}减{{ birthdayObj.data.amount }}</p>
            <img class="close" src="./../../image/scflow/close.png" @click="closeBirth()">
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
export default {
    name: 'birthdayComponent',
    props: ['birthdayObj'],
    data() {
        return {};
    },
    methods: {
        usebirCount(url) {
            this.$emit('close');
            //前往使用生日优惠券
            this.$router.push({
                path: `/usercateList`
            });
        },
        closeBirth() {
            this.$emit('close');
        }
    }
};
</script>
<style lang="less" rel="stylesheet/less" scoped>
.birthday {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: 60;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.7);
    .discount_bg {
        position: relative;
        width: 9.973rem;
        height: 11.747rem;
        background: url(../../image/scflow/birth_count.png) no-repeat;
        background-size: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .birth_usebtn {
            position: absolute;
            top: 7.307rem;
            left: 48%;
            transform: translateX(-50%);
            width: 4.373rem;
            height: 1.587rem;
        }
        .price {
            position: absolute;
            left: 48%;
            transform: translateX(-50%);
            top: 6.333rem;
            font-size: 0.747rem;
            color: #f5dbaa;
            line-height: 1;
            white-space: nowrap;
            // background-image: -webkit-gradient(linear, 0 0, 0 bottom, from(#fdf7eb), to(#f9dba4));
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
            text-shadow: 0.067rem 0.067rem #d33936;
        }
        .close {
            position: absolute;
            bottom: 0.533rem;
            width: 0.547rem;
            height: 0.547rem;
        }
    }
}
</style>



// WEBPACK FOOTER //
// birthdayComponent.vue?5eed1da4